import moment from "moment-timezone";

export const convertNYTimeToUTC = (datetimeString) => {
  if (datetimeString) {
    return moment.tz(datetimeString, "America/New_York").utc();
  }
  return "NA";
};
